
import { defineComponent, computed, PropType, ref } from 'vue'
import { convertToWidthCharacter, customFilterDropdown } from '@/utils'

const DEFAULT_MENU_PROPS = {
  closeOnClick: false,
  closeOnContentClick: false,
  disableKeys: true,
  openOnClick: false,
  minWidth: 80,
  offsetY: true,
  offsetOverflow: true,
  top: true,
  transition: false
}

export default defineComponent({
  name: 'AppCombobox',
  props: {
    value: {
      type: null as any,
      default: null
    },
    items: {
      type: Array as PropType<any[]>,
      default: () => []
    },
    // optional override for menu props
    menuProps: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({})
    }
  },

  emits: ['input', 'update:searchInput'],

  setup(props, { emit }) {
    const searchInput = ref<string>('')
    const comboRef = ref<any>(null)

    const computedMenuProps = computed(() => {
      const isMatch = props.items.find((item) => {
        return customFilterDropdown(item, searchInput.value, null)
      })
      if (isMatch) {
        return { ...DEFAULT_MENU_PROPS, ...props.menuProps }
      } else {
        return { value: false }
      }
    })

    const onSearchInputUpdate = (val: string) => {
      emit('update:searchInput', val)
    }

    const blur = () => {
      comboRef.value?.blur?.()
    }

    return {
      searchInput,
      comboRef,
      computedMenuProps,
      onSearchInputUpdate,
      customFilterDropdown,
      blur
    }
  }
})
